module.exports = __webpack_public_path__ + "img/Cardone.e2268108.png";